const isLocalizedRequest = (request) => {
  return "locale" in request;
};
export {
  isLocalizedRequest
};
//# sourceMappingURL=types.js.map
